import PropTypes from 'prop-types';
import React from 'react';
import { VaPagination } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import InquiryCard from './InquiryCard';

/**
 * @typedef {import('./InquiryCard').Inquiry} Inquiry
 */

/**
 * @param {{
 *   inquiries: Inquiry[],
 *   listClassName: string,
 *   currentPage: number,
 *   totalPages: number,
 *   onPageChange: (page: number) => void,
 * }} props
 */
export default function InquiryCardList({
  inquiries,
  listClassName,
  currentPage,
  totalPages,
  onPageChange,
}) {
  if (!inquiries.length) {
    return (
      <div className="no-results-alert">
        <va-alert
          close-btn-aria-label="Close notification"
          slim
          status="info"
          visible
        >
          <p className="vads-u-margin-y--0">
            No questions match your search criteria
          </p>
        </va-alert>
      </div>
    );
  }

  return (
    <>
      <ul className={listClassName}>
        {inquiries.map(inquiry => (
          <li key={inquiry.id}>
            <InquiryCard {...{ inquiry }} />
          </li>
        ))}
      </ul>
      {totalPages > 1 && (
        <VaPagination
          page={currentPage}
          pages={totalPages}
          maxPageListLength={5}
          showLastPage
          onPageSelect={({ detail }) => onPageChange(detail.page)}
          className="vads-u-border-top--0 vads-u-padding-top--0 vads-u-padding-bottom--0"
        />
      )}
    </>
  );
}

InquiryCardList.propTypes = {
  currentPage: PropTypes.number.isRequired,
  inquiries: PropTypes.arrayOf(InquiryCard.propTypes.inquiry).isRequired,
  listClassName: PropTypes.string.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};
